export const NEXT_PUBLIC_GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export const setVariables = variables => {
  window.dataLayer = window.dataLayer ?? [];
  window?.dataLayer?.push?.(variables);
};

export const event = (event, { category = '', label = '', value = '' } = {}, variables = {}) => {
  window.dataLayer = window.dataLayer ?? [];
  window?.dataLayer?.push?.({
    event: event,
    event_category: category,
    event_label: label,
    value,
    ...variables,
  });
};
